export default __webpack_public_path__ + "static/media/photo_5282747746622312906_y.055a26f6.jpg";